import { useSelector } from '@xstate/react';
import { useAppSettings } from 'src/state/context/AppSettings';

export const useValidateUser = () => {
  const { validateLogInUserMachine } = useAppSettings();
  const isValidatingUser = useSelector(validateLogInUserMachine, (state) => state.tags.has('validatingUser'));

  return { isValidatingUser };
}
